module.exports = __webpack_public_path__ + "static/media/game(9).893d0fe9.PNG";